export default __webpack_public_path__ + "static/media/diaganostic104.8c9e2bf8.jpg";